import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Cart, CheckoutTypeEnum, GenericUser, UserTypes } from "../_models";
import { DataService } from "../_services/data.service";
import { AlertService } from "../_services/alert.service";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { DomSanitizer } from "@angular/platform-browser";
import { SessionManagerService } from "../_services/SessionManager/session-manager.service";
import { EmailValidationPattern } from "../_helpers/validateEmail";
import { LocalStorageManagerService } from "../_services/localStoageManager.service";
import { CheckoutPaymentType } from "../_models/checkout-payment-type";
import { LoggerService } from "../modules/logger/logger.service";
import { UserPermissionType } from "../_models/user/user-permission-type";
import { GenericModalComponent } from "../form/generic-app-modal/generic-modal.component";
import { autoFillForms } from "../_helpers/auto-fill-forms/auto-fill-forms";

@Component({
  moduleId: module.id,
  selector: "checkout",
  templateUrl: "checkout.component.html",
  styleUrls: ["checkout.component.scss"],
})
export class CheckoutComponent implements OnInit {
  public videoId: any;
  public cart: Cart | null;
  public numberOfPayments: number;
  public paymentType: CheckoutPaymentType = CheckoutPaymentType.Credit;

  public confirmation1: boolean = false;
  public confirmation2: boolean = false;
  public isMeshutaf: boolean = false;
  public isCash: boolean = false;
  public messages: any;
  public currentUser: any;
  public contribution: any;
  public payments: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  public modalContributionReference: any;
  public modelTalpan: any = {};
  public modalTalpanReference: any;
  public modalGeneralReference: any;
  public loading = false;

  public removingEvent: any;
  public loadingContribution1 = false;
  public loadingContribution2 = false;
  public loadingContribution3 = false;
  public loadingContribution4 = false;
  public upperPaymentText: string = "";
  public lowerPaymentText: string = "";

  public screenType: CheckoutTypeEnum;
  public screenTypeEnum = CheckoutTypeEnum;
  public readonly CheckoutPaymentType = CheckoutPaymentType;
  public readonly emailValidationPattern = EmailValidationPattern;

  constructor(
    private router: Router,
    public dataService: DataService,
    private alertService: AlertService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private sessionManger: SessionManagerService,
    private localStorageManager: LocalStorageManagerService,
    private logger: LoggerService
  ) {
    this.messages = JSON.parse(this.localStorageManager.getItem("messages"));

    this.currentUser = JSON.parse(
      this.localStorageManager.getItem("currentUser")
    );
    if (this.currentUser && this.currentUser.role) {
      if (this.currentUser.role === "USER") {
        this.screenType = CheckoutTypeEnum.PARENT;
      } else if (
        this.currentUser.role === "ADMIN" &&
        this.currentUser.type &&
        this.currentUser.type === UserTypes.TYPE_TALPAN
      ) {
        this.screenType = CheckoutTypeEnum.TALPAN;
      } else if (
        this.currentUser.role === "ADMIN" &&
        this.currentUser.type &&
        this.currentUser.type === UserTypes.TYPE_MESHUTAF
      ) {
        this.screenType = CheckoutTypeEnum.MESHUTAF;
      } else if (
        this.currentUser.role === "ADMIN" &&
        this.currentUser.type &&
        this.currentUser.type === UserTypes.TYPE_MOBILE_ONLY
      ) {
        this.screenType = CheckoutTypeEnum.CASH_ONLY;
      } else if (
        this.currentUser.role === "ADMIN" &&
        this.currentUser.type &&
        (this.currentUser.type === UserTypes.TYPE_TALPAN_WITH_MOBILE ||
          this.currentUser.type >= UserTypes.TYPE_RAKAZ_KEN)
      ) {
        this.screenType = CheckoutTypeEnum.RAKAZ_OR_TALPAN_WITH_CASH;
      }
    }
    const contributions = this.localStorageManager.getItem("contributions")
      ? JSON.parse(this.localStorageManager.getItem("contributions"))
      : undefined;

    this.contribution =
      contributions && contributions.length && contributions.length > 0
        ? contributions[0]
        : undefined;
    this.videoId =
      this.currentUser && this.currentUser.videoId
        ? this.currentUser.videoId
        : "A7KWBNbU2zY";

    this.upperPaymentText = this.getTextForCheckout("upperPayment");
    this.lowerPaymentText = this.getTextForCheckout("lowerPayment");
    this.dataService.cart.subscribe((nextVal) => {
      this.cart = nextVal;

      this.updateScreenFromCart();
      this.setPaymentsNumber();
    });
    autoFillForms(this, { shouldSubmit: false });
  }

  public openContributionModal(content) {
    const options: NgbModalOptions = {
      windowClass: "contribution-modal",
      backdrop: "static",
    };
    this.modalContributionReference = this.modalService.open(content, options);
  }

  public openTalpanModal(content) {
    const options: NgbModalOptions = {
      windowClass: "talpan-modal",
      backdrop: "static",
    };
    this.modalTalpanReference = this.modalService.open(content, options);
  }

  public openGeneralModal(content) {
    const options: NgbModalOptions = {
      windowClass: "talpan-modal",
      backdrop: "static",
    };
    this.modalGeneralReference = this.modalService.open(content, options);
  }

  public submitTalpan() {
    this.sendPaymentRequest();
    this.modalTalpanReference.close();
  }

  public removeFromCart(item) {
    this.removingEvent = item.eventId;
    item.isInCart = false;
    this.dataService.removeFromCart(item).subscribe(
      (_data) => {
        this.removingEvent = undefined;
      },
      (error) => {
        this.removingEvent = undefined;
        this.alertService.error(error);
      }
    );
  }

  public checkout(contentContribution, contentTalpan) {
    this.alertService.clear();
    if (!this.confirmation1 || !this.confirmation2) {
      this.alertService.error(this.messages.checkout_confirmation);
    } else if (this.numberOfPayments == null || this.numberOfPayments < 1) {
      this.alertService.error("בחר מספר תשלומים");
    } else {
      //check talpan or admin
      if (
        this.currentUser &&
        this.currentUser.role === "ADMIN" &&
        (!this.modelTalpan ||
          !this.modelTalpan.firstName ||
          !this.modelTalpan.email ||
          !this.modelTalpan.personalId ||
          !this.modelTalpan.lastName)
      ) {
        this.openTalpanModal(contentTalpan);
      }
      //check contribution
      else if (
        this.contribution &&
        this.currentUser.role === "USER" &&
        this.currentUser.shouldNotify &&
        !this.hasContributionInCart()
      ) {
        this.openContributionModal(contentContribution);
      } else {
        this.sendPaymentRequest();
      }
    }
  }

  public checkoutMeshutaf(contentMeshutaf) {
    this.alertService.clear();
    if (!this.confirmation1 || !this.confirmation2) {
      this.alertService.error(this.messages.checkout_confirmation);
    } else {
      this.loading = true;
      this.dataService.checkoutMeshutaf().subscribe(
        (_data) => {
          this.loading = false;

          this.dataService.cart.next(null);
          this.localStorageManager.setItem("cart", JSON.stringify({}));
          this.openGeneralModal(contentMeshutaf);
        },
        (error) => {
          this.loading = false;
          const body = error.json && error.json();
          this.alertService.error(
            body && body.statusText
              ? this.messages[body.statusText]
                ? this.messages[body.statusText]
                : decodeURIComponent(body.statusText)
              : (error && error.statusText) || error
          );
        }
      );
    }
  }

  public checkoutCash(contentCash) {
    this.alertService.clear();
    if (!this.confirmation1 || !this.confirmation2) {
      this.alertService.error(this.messages.checkout_confirmation);
    } else if (this.numberOfPayments == null || this.numberOfPayments < 1) {
      this.alertService.error("בחר מספר תשלומים");
    } else {
      this.openGeneralModal(contentCash);
    }
  }
  public checkoutFreePay(contentFreePay) {
    this.alertService.clear();
    if (!this.confirmation1 || !this.confirmation2) {
      this.alertService.error(this.messages.checkout_confirmation);
    } else {
      if (
        this.sessionManger.getCurrentUserPermissions().userType ===
        UserPermissionType.ParentUser
      ) {
        if (!this.loading) {
          this.loading = true;
          this.dataService.postEntity("checkout-without-paying", {}).subscribe(
            (data) => {
              this.loading = false;
              const modalRef = this.modalService.open(GenericModalComponent);
              modalRef.componentInstance.modalOptions = {
                approveOption: "אישור",
                cancelOption: "",
                modalHeader: "הרשמה",
                modalText: "ההרשמה בוצעה בהצלחה.",
                onlyApprove: true,
              };
              modalRef.result.then((r) => {
                this.modalGeneralReference = modalRef;
                this.generalSuccess();
              });
            },
            (error) => {
              this.loading = false;
              let body = error.json && error.json();
              this.alertService.error(
                body && body.statusText
                  ? this.messages[body.statusText]
                    ? this.messages[body.statusText]
                    : decodeURIComponent(body.statusText)
                  : (error && error.statusText) || error
              );
            }
          );
        }
        return;
      }
      this.openGeneralModal(contentFreePay);
    }
  }

  public generalSuccess() {
    this.modalGeneralReference.close();
    this.dataService.cart.next(null);
    this.localStorageManager.setItem("cart", JSON.stringify({}));
    this.router.navigate(["/"]).then();
  }

  public sendPaymentRequest() {
    this.loading = true;
    let req = {};
    if (this.modelTalpan && this.modelTalpan.firstName) {
      req["tellerData"] = this.modelTalpan;
      req["numberOfPayments"] = this.numberOfPayments;
    } else {
      req = { numberOfPayments: this.numberOfPayments };
    }
    this.dataService.checkout(req).subscribe(
      (data) => {
        this.loading = false;
        this.modelTalpan = {};

        if (data && data.redirect) {
          window.location.href = data.redirect;
        }
      },
      (error) => {
        this.loading = false;
        this.alertService.error(error);
      }
    );
  }

  public sendUserContribution() {
    this.dataService.updateNotification().subscribe(
      (_data) => {
        this.currentUser.shouldNotify = false;
        this.localStorageManager.setItem(
          "currentUser",
          JSON.stringify(this.currentUser)
        );
        this.sessionManger.setUser(this.currentUser as GenericUser);
      },
      (error) => {
        this.logger.error(error);
      }
    );
  }

  public hasContributionInCart() {
    let hasContribution = false;
    if (
      this.contribution &&
      this.cart &&
      this.cart.items &&
      this.cart.items.length
    ) {
      this.cart.items.forEach((cartItem) => {
        if (cartItem.item.isContribution) {
          hasContribution = true;
        }
      });
    }
    return hasContribution;
  }

  public getChildDataForContribution() {
    if (this.cart && this.cart.items && this.cart.items.length) {
      return {
        childId: this.cart.items[0].item.childId,
        firstName: this.cart.items[0].item.firstName,
        lastName: this.cart.items[0].item.lastName,
      };
    } else {
      return;
    }
  }

  public getTextForCheckout(divId) {
    let text;
    if (divId && this.localStorageManager.getItem("texts") !== "undefined") {
      const texts = JSON.parse(this.localStorageManager.getItem("texts"));

      if (texts && texts[divId] && texts[divId].trim() !== "") {
        text = texts[divId];
      }
    }

    if (
      divId &&
      !text &&
      this.localStorageManager.getItem("generalTexts") !== "undefined"
    ) {
      const generalTexts = JSON.parse(
        this.localStorageManager.getItem("generalTexts")
      );
      if (generalTexts && generalTexts.length && generalTexts.length > 0) {
        generalTexts.forEach((t) => {
          if (t.divId && t.divId === divId) {
            text = t.divText;
          }
        });
      }
    }
    return text;
  }

  public addContribution(price, index, fromModal) {
    if (this.contribution && price && price > 0) {
      const child = this.getChildDataForContribution();

      if (child && child.childId) {
        this.contribution.childId = child.childId;
        this.contribution.firstName = child.firstName;
        this.contribution.lastName = child.lastName;
      }

      this.setContributionLoader(index, true);
      this.contribution.price = price;
      this.dataService.addToCart(this.contribution).subscribe(
        (_data) => {
          this.setContributionLoader(index, false);
          if (fromModal) {
            this.modalContributionReference.close();

            this.saveUserContribution();
          }
        },
        (_error) => {
          this.setContributionLoader(index, false);
        }
      );
    }
  }

  public setContributionLoader(index: number, value: boolean) {
    if (index === 1) {
      this.loadingContribution1 = value;
    } else if (index === 2) {
      this.loadingContribution2 = value;
    } else if (index === 3) {
      this.loadingContribution3 = value;
    } else if (index === 4) {
      this.loadingContribution4 = value;
    }
  }

  public saveUserContribution() {
    if (this.currentUser.shouldNotify) {
      this.sendUserContribution();
    }
    this.modalContributionReference.close();

    this.sendPaymentRequest();
  }

  public ngOnInit() {
    this.loadAllData();
  }

  public setPaymentsNumber() {
    if (
      this.cart &&
      this.cart["totalPrice"] > 0 &&
      this.cart["onePayment"] > 0 &&
      this.cart["maxPayments"] > 0
    ) {
      let numberPayments: number =
        this.cart["totalPrice"] / this.cart["onePayment"];
      // tslint:disable-next-line:radix
      numberPayments = parseInt(numberPayments + "");
      numberPayments =
        !numberPayments || numberPayments === 0 ? 1 : numberPayments;
      numberPayments =
        numberPayments < this.cart["maxPayments"]
          ? numberPayments
          : this.cart["maxPayments"];
      this.payments = [];
      for (let i = 1; i <= numberPayments; i++) {
        this.payments.push(i);
      }
    }
  }

  public updateScreenFromCart() {
    if (
      this.cart &&
      this.cart.items &&
      this.cart.items.length &&
      this.cart.items.length > 0 &&
      this.cart.items[0].item &&
      this.cart.items[0].item.isMeshutaf === true
    ) {
      this.isMeshutaf = true;
      this.paymentType = CheckoutPaymentType.None;
    }
    if (
      this.cart &&
      this.cart.items &&
      this.cart.items.length &&
      this.cart.items.length > 0 &&
      this.cart.items[0].item &&
      this.cart.items[0].item.cashOnly === true
    ) {
      this.isCash = true;
      this.paymentType = CheckoutPaymentType.None;
    } else {
      this.paymentType = CheckoutPaymentType.Credit;
    }
    this.updateIsFreePurchase();
  }

  public formatNum(num: number) {
    return Number.isInteger(num) ? num : Number(num).toFixed(2);
  }

  public handleAddContribution($event: {
    price: number;
    index: number;
    fromModal: boolean;
  }) {
    return this.addContribution($event.price, $event.index, $event.fromModal);
  }

  private updateIsFreePurchase() {
    if (
      this.cart &&
      this.cart.items &&
      this.cart.items.length &&
      this.cart.totalPrice === 0
    ) {
      this.paymentType = CheckoutPaymentType.FreeCheckout;
    }
  }

  private loadAllData() {
    try {
      this.cart = JSON.parse(this.localStorageManager.getItem("cart"));
      this.updateScreenFromCart();
      this.setPaymentsNumber();
    } catch (e) {
      this.logger.error("loadAllData", JSON.stringify(e));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/checkout/checkout.component.ts